<template>
  <div class="pagehead">
    <div class="pageheadFont">
      {{ title }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>

<style lang='scss' scoped>
.pagehead {
  background-color: #fff;
  padding: 0 0 10px 44px;
  color: rgba(56, 56, 56, 1);
  .pageheadFont{
  font-size: 18px;
  font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageHead.vue